import {Emitter} from './emitter';
import {QuantitySelector} from './quantity_selector';
import {formatMoney} from '@shopify/theme-currency';

export const
    STATE_NON_SUBMITTABLE = 'non_submittable',
    STATE_SUBMITTABLE = 'submittable',
    STATE_SUBMITTING = 'submitting',
    STATE_SUBMITTED = 'submitted',
    STATE_FAILED = 'failed';


export class AddToCartForm extends Emitter {
    constructor(cart, form, options = {}) {
        super();
        this.cart = cart;
        this.form = form;
        this.options = options;
        this.formData = null;
        this.product = null;
        this.rcLoaded = null;
        this.activeProductDiscount = null;
        this.bundleDiscount = null;
        this.activeVariantIndex = undefined;
        this.subscriptionSelected = false;
        this.frequency = null;
        this.state = STATE_NON_SUBMITTABLE;
        this.handleVariantSelected = this.handleVariantSelected.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBoldEvent = this.handleBoldEvent.bind(this);
        this.rcRadioButtons = this.rcRadioButtons.bind(this);
        this.rcSubSave = this.rcSubSave.bind(this);
        this.rcOneTime = this.rcOneTime.bind(this);
        this.setSubscription = this.setSubscription.bind(this);
        this.handleQuantityChanger = this.handleQuantityChanger.bind(this);
        this.variantSelect = form.find('.variant-select');
        this.quantitySelector = new QuantitySelector(form.find('.v4-quantity-selector')).on('change', this.handleQuantityChanger);
        this.submitButton = $(form.find('.add-to-cart-button'));
        this.rechargeSubscribtion = form.find('.rc-container-wrapper');
        this.variantSelect.on('change', this.handleVariantSelected);
        this.currencySymbol = currencySymbol;
        form.on('submit', this.handleSubmit);
    }
    setSubscriptionFrequency(frequency) {
        this.frequency = frequency;
    }
    subscriptionProductPrice() {
        const { product, activeVariantIndex } = this;
        const variant = product.getVariants(activeVariantIndex)[0];
        if(variant.compare_at_price > variant.price){
            return variant.price;
        } else {
            return this.getSellingPlanAllocationPrice(variant);
        }
    }

    getSellingPlanAllocationPrice(sellingPlans) {
        for(let i = 0; i < sellingPlans.selling_plan_allocations.length; i++) {
            const sellingPlan = sellingPlans.selling_plan_allocations[i];
            return sellingPlan.per_delivery_price;
        }

        return null;
    }

    handleQuantityChanger(e, value) {
        const { product, form, subscriptionSelected, activeVariantIndex} = this,
            handle = product.handle(), block = form.parent(), activeVariant = product.getVariants(activeVariantIndex);
        let productPrice = product.getVariants(activeVariantIndex)[0].price,
            html = null;
        if(subscriptionSelected)
            productPrice = this.subscriptionProductPrice();

        if (typeof discount_products_base_on_qty[handle] !== 'undefined') {
            const discount = discount_products_base_on_qty[handle].discount,
                discount_threshold = discount_products_base_on_qty[handle].discount_threshold;
            if (value >= discount_threshold) {
                const leftOver = value % discount_threshold,
                    howManyPromotion = (value - leftOver) / discount_threshold;
                const calculatedObj = this.calculatePercentage(discount_threshold, discount, leftOver, howManyPromotion, productPrice, value);
                html = product.formatSpecialPrice(calculatedObj, howManyPromotion * discount_threshold);
                this.updateButton(activeVariantIndex, product.available(), value);
                this.emit('quantitychange', true, calculatedObj.new_discount, activeVariant[0]);
            } else {
                this.updateButton(activeVariantIndex, product.available(), value);
            }
        }
        
        if (product.isDiscounted(activeVariantIndex)) {
            html = product.formatPricing(activeVariantIndex, {
                html: true,
                comparison: true,
                // label: 'Special Price: ',
                quantity: value,
            });
        }
        
        this.updateButton(activeVariantIndex, product.available(), value);

        $(block).find('.pricing').html(html !== null ? html : '');
        $(block).toggleClass('discounted', html !== null);
    }

    calculatePercentage(discount_threshold, discount, leftProductsQty, promotion, price, qty) {
        const promotionProductCount = promotion * discount_threshold,
            discountedPrice = price - (price * discount / 100),
            nonDiscountedProductsPrice = price * leftProductsQty,
            discountedFullProductsPrice = (discountedPrice * promotionProductCount) + nonDiscountedProductsPrice;
            // calucate new discount for all products
            const originalProductsPrice = price * qty;
            let newDiscount = (discountedFullProductsPrice / originalProductsPrice) * 100;
            newDiscount = 100 - newDiscount;

            return {'new_discount': newDiscount, 'discounted_full_price': discountedFullProductsPrice, 'original_full_price': originalProductsPrice};
    }

    setState(state) {
        if (this.state === state)
            return;

        this.state = state;
        this.form
            .toggleClass('submittable', state === STATE_SUBMITTABLE)
            .toggleClass('submitted', state === STATE_SUBMITTED || state === STATE_FAILED)
            .toggleClass('success', state === STATE_SUBMITTED)
            .toggleClass('failed', state === STATE_FAILED);
        this.emit('statechange', this, state);
    }

    updateButton(variantIndex, available, qty = 1) {
        const
            {product} = this,
            customCaption = product.metafield('buy_caption'),
            customUrl = product.metafield('buy_url'),
            price = product.formatPricing(variantIndex, {html: true, comparison: false, quantity: qty});
        let caption;
        if (available)
            caption = ABV4_SETTINGS.addToCartText !== null ? ABV4_SETTINGS.addToCartText : 'Add to Cart';
        else
            caption = "Coming Soon";

        if (customCaption !== null)
            caption = customCaption;
        
        const classes = ['add-to-cart-button'];
        if (price !== null)
            classes.push('has-price');
        if (!available)
            classes.push('disabled');

        const attributes = `class="${classes.join(' ')}" ${available ? '' : 'disabled'}`;

        let html, inner =
            `<span class="caption">${caption}</span>
            <span class="separator">|</span>
            <span class="price">${price}</span>`;
        if (customUrl !== null) {
            html = `<a target="_blank" href="${customUrl}" ${attributes}>${inner}</a>`;
        } else {
            html = `<button name="add" type="submit" ${attributes}>${inner}</a>`;
        }

        const newButton = jQuery(html);
        this.submitButton.replaceWith(newButton);
        this.submitButton = newButton;
    }

    populateForVariant(variantIndex) {
        const
            {state, product} = this,
            available = product.available(variantIndex);
        this.quantitySelector.reset(product.handle()).enable(available);
        this.updateButton(variantIndex, available, this.quantitySelector.value());

        if (state === STATE_NON_SUBMITTABLE || state == STATE_SUBMITTABLE)
            this.setState(available ? STATE_SUBMITTABLE : STATE_NON_SUBMITTABLE);
    }

    setActiveVariant(variantIndex) {
        this.populateForVariant(variantIndex);
        this.emit('variantselected', this.product, variantIndex);
        this.activeVariantIndex = variantIndex;
        if (this.rcLoaded)
            this.rcUpdatePrice();


        const handle = this.product.handle();
        this.quantitySelector.setProductCartQuantity(handle);
    }

    handleVariantSelected(e) {
        if (this.product === null)
            return;
        const variantIndex = this.product.findVariantById(e.target.value);
        this.quantitySelector.stepupReset();
        const variant = this.product.getVariants(variantIndex);
        // this.quantitySelector.setProductCartQuantity();
        this.setActiveVariant(variantIndex);
    }

    populateVariantSelect(product) {
        const {variantSelect} = this, {ajax: {variants}} = product, options = [];
        let initialVariantIndex = null;

        for (let index = 0; index < variants.length; ++index) {
            const variant = variants[index], attributes = [];
            if (variant.available) {
                if (initialVariantIndex === null) {
                    attributes.push('selected');
                    initialVariantIndex = index;
                }
            } else {
                attributes.push('disabled');
            }

            const
                attributeString = attributes.join(' '),
                option = `<option value="${variant.id}" ${attributeString}>${variant.title}</option>`;
            options.push(option);
        }

        variantSelect.html(options.join('\n'));
        return initialVariantIndex;
    }

    updateProductClasses(product) {
        this.form
            .toggleClass('unavailable', !product.available())
            .toggleClass('external', product.metafield('buy_url') !== null)
            .toggleClass('multiple-variants', product.hasMultipleVariants());
    }

    setProduct(product) {
        this.product = product;
        this.activeVariantIndex = undefined;
        this.setState(STATE_NON_SUBMITTABLE);
        if (ABV4_SETTINGS.recharge_subscription.enable)
            this.setSubscription(product);
 
        this.updateProductClasses(product);
        let initialVariantIndex;
        const selectedVariant = this.findGetParameter('variant');
        if (selectedVariant !== null) {
            initialVariantIndex = this.populateVariantSelect(product);
            initialVariantIndex = product.findVariantById(selectedVariant);
        } else {
            initialVariantIndex = this.populateVariantSelect(product);
        }

        this.setActiveVariant(initialVariantIndex);
    }


    findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
            tmp = items[index].split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        }
        return result;
    }

    handleBoldEvent(e) {
        this.populateForVariant(this.activeVariantIndex);
    }

    handleSubmit(e) {
        e.preventDefault();
        const popupContainer = $('.v4-add-to-cart-popup');
        popupContainer.find('.v5-upsell-popup-heading').text(' ');
        popupContainer.find('.cart-bundle-wrapper').remove();
        const {state} = this;
        if (state !== STATE_SUBMITTABLE)
            return;

        this.setState(STATE_SUBMITTING);
        this.emit('submitting', this);
        let productHandle = popupContainer.attr('data-popup-product-handle');
        if(productHandle == undefined) {
            productHandle = $('.v4-single-product-section').attr('data-popup-product-handle');
        }
        const productVariant = this.product.getVariants(this.activeVariantIndex)[0];

        const item = {
            Name: productVariant.name,
            ProductVariantID: productVariant.id,
            ProductHandle: this.product.ajax.handle,
        };

        _learnq.push(['track', 'Added to Cart', item]);

        let formData = this.getFormData(null, true);
        // comment
        if(ABV4_SETTINGS.sales.bf_2022 === true && bf_2022_sale[productHandle]) {
            const gifts = bf_2022_sale[productHandle], items = [],
                boughtProductQty = formData.quantity,
                productObjct = this.product.ajax, variantHandle = productVariant.option1;
            let count = 0, bundleName = formData['properties[_bundle]'],
                bundleClass = formData['properties[_bundle_class]'];

                if(typeof bundleName == 'undefined') {
                    formData['properties[_bundle]'] = productVariant.name;
                    formData['properties[_bundle_class]'] = productHandle + "-" + variantHandle;
                    // formData['properties[_product_price]'] = productVariant.compare_at_price ? productVariant.compare_at_price / 100 : productVariant.price / 100;
                    formData['properties[_bundle_discount]']  = 0;
                    formData['properties[_base_product_qty]'] = 1;
                    formData['properties[_single_product]'] = false;
                    formData['properties[_black_friday]'] = true;
                }

            for(let i = 0; i < gifts.length; i++) {
                const gift = gifts[i];
                const isGiftAvailable = this.giftProductAvailability(gift.id);
                if(isGiftAvailable) {
                    count ++;
                    if(count === 1) {
                        bundleName = formData['properties[_bundle]'] + ' and free gift'
                        bundleClass = formData['properties[_bundle_class]'] + '_and_free_gift'
                    } else if (count > 1) {
                        bundleName = formData['properties[_bundle]'] + ' and free gifts'
                        bundleClass = formData['properties[_bundle_class]'] + '_and_free_gifts'
                    }
                }
            }

            count = 0;

            for(let i = 0; i < gifts.length; i++) {
                count = i + 1;
                const gift = gifts[i];
                const isGiftAvailable = this.giftProductAvailability(gift.id);
                if(isGiftAvailable) {
                    items.push({
                        id: gift.id,
                        quantity: boughtProductQty,
                        properties: {
                            "_bundle": bundleName,
                            "_bundle_discount": this.freeProductPrice(gift.price),
                            "_bundle_class": bundleClass,
                            // "_product_price": gift.price,
                            "_base_product_qty": 1,
                            "_single_product": false,
                            "_black_friday": true,
                            "_free_bundle_component": true
                        }
                    });
                    formData['properties[_bundle]'] = bundleName;
                    formData['properties[_bundle_class]'] = bundleClass;
                    formData['properties[_single_product]'] = false;
                    formData['properties[_black_friday]'] = true;
                    formData['gift_product_count'] = count;
                }
            }
            if(items.length > 0) {
                items.push(formData);
                formData = {"items": items}
            }

        }
        jQuery.ajax({
            url: '/cart/add.js',
            type: 'POST',
            data: formData,
            dataType: 'text'
        }).done((response) => {
            this.cart.fetch();
            const finalState = this.options.once ? STATE_SUBMITTED : STATE_SUBMITTABLE;
            this.setState(finalState);
            this.emit('submitted', this);
        }).fail((xhr, error) => {
            this.setState(STATE_FAILED);
            this.emit('submitfailed', this);
        });
    }

    giftProductAvailability(id) {
        let result = false;
        if(typeof available_bundle_variants[id] != 'undefined') {
            result = true;
        }

        return result;
    }

    freeProductPrice(price) {
        const calculateDiscount = 1 / price;
        const result = 100 - calculateDiscount;

        return result;
    }

    getFormData(name = null, update = false) {
        let formData = this.formData;
        if (update || formData === null) {
            const {form} = this;
            formData = {};
            for (const item of form.serializeArray())
                formData[item.name] = item.value;
            this.formData = formData;
        }

        return name !== null ? formData[name] : formData;
    }

    setSubscription(product) {
        const sellingPlanGroup = product.getSellingPlan();
        if (this.rcLoaded) {
            this.rcReset();
        }

        if (sellingPlanGroup !== null) {
            this.rcLoaded = true;
            const variants = product.getVariants(0),
                sellingPlanPrice = variants[0].selling_plan_allocations[0].price;
            let originalPrice = variants[0].selling_plan_allocations[0].compare_at_price;
            if(variants[0].compare_at_price > variants[0].price){
                originalPrice = variants[0].compare_at_price;
            }
            this.sellingPlanOption(sellingPlanGroup.selling_plans, sellingPlanPrice, originalPrice);
            this.rechargeSubscribtion.removeClass('d-none');
        } else {
            this.rcLoaded = false;
            this.subscriptionSelected = false;
        }
    }

    sellingPlanOption(sellingPlans, sellingPlanPrice, originalPrice) {
        const spOptionContainer = this.rechargeSubscribtion.find('select.rc-selling-plan-options'),
            rcPriceContainer = this.rechargeSubscribtion.find('.rc-radio-subsave .rc-option-price'),
            rcOnetimePriceContainer = this.rechargeSubscribtion.find('.rc-onetime-option-selector .rc-option-price'),
            rcPricePercentage = this.rechargeSubscribtion.find('.rc-radio-subsave .rc-option-discount'),
            originalPriceContainer = this.rechargeSubscribtion.find('.rc-option-price');
        rcPriceContainer.text(formatMoney(sellingPlanPrice, window.moneyFormat));
        rcOnetimePriceContainer.text(formatMoney(originalPrice, window.moneyFormat));
        let options = '';
        let pricePercentage;
        for (let i = 0; i < sellingPlans.length; i++) {
            const sellingPlan = sellingPlans[i];
            pricePercentage = sellingPlan.price_adjustments[0].value;
            options += `<option value="${sellingPlan.id}">${sellingPlan.name}</option>`;
        }

        rcPricePercentage.text(pricePercentage + '%');
        spOptionContainer.html(options);
        spOptionContainer.attr('selected', false);
        spOptionContainer.prepend('<option value="" selected></option>');
        this.rcRadioButtons();
    }

    rcRadioButtons() {
        const rcOneTime = this.rechargeSubscribtion.find('input[name="onetime"]'),
            rcSubSave = this.rechargeSubscribtion.find('input[name="subsave"]');
        rcOneTime.on('click', this.rcOneTime);
        rcSubSave.on('click', this.rcSubSave);
    }

    rcSubSave(e) {
        const { product, frequency } = this;
        const rcOneTime = this.rechargeSubscribtion.find('input[name="onetime"]'),
            rcSubSave = $(e.target),
            spOptionContainer = this.rechargeSubscribtion.find('select.rc-selling-plan-options');
        rcOneTime.prop('checked', false);
        rcSubSave.prop('checked', 'checked');
        spOptionContainer.removeClass('d-none');
        spOptionContainer.prop('required', 'required');
        if (spOptionContainer.find('option:first').val() === '')
            spOptionContainer.find('option:first').remove();
        let selected = '';
        if(frequency !== null) {
            let frequencyArr = [frequency];
            if(typeof frequency !== 'number') {
                frequencyArr = frequency.split(',');
            }
            this.showSpecificFrequency(frequencyArr, spOptionContainer);
        }
        if(frequency === null){
            for (let i = 0; i < spOptionContainer.find('option').length; i++) {
                const option = spOptionContainer.find('option')[i];
                if ($(option).text().includes('4')) {
                    const value = $(option).val();
                    $(option).prop('selected', 'selected');
                    spOptionContainer.val(value);
                }
            }
        }
        this.quantitySelector.reset(product.handle());
        this.quantitySelector.stepupReset();
        this.rcUpdatePrice();
    }

    showSpecificFrequency(frequencyArr, selectOptions) {
        const validOptions = [];
        let firstFinded = true;
            for (let i = 0; i < selectOptions.find('option').length; i++) {
                let isIncluded = false;
                const option = selectOptions.find('option')[i];
                for(const [index,item] of frequencyArr.entries()) {
                    if ($(option).text().includes(item)) {
                        isIncluded = true;
                    }
                }
                if(isIncluded && firstFinded) {
                    firstFinded = false;
                    $(option).prop('selected', 'selected');
                    $(selectOptions).val($(option).val());
                } else if(isIncluded === false) {
                    $(option).addClass('d-none');
                } else if(isIncluded) {
                    $(option).removeClass('d-none');
                } else {}
            }
    }

    rcOneTime(e) {
        const { product } = this;

        const rcSubSave = this.rechargeSubscribtion.find('input[name="subsave"]'),
            spOptionContainer = this.rechargeSubscribtion.find('select.rc-selling-plan-options'),
            rcOneTime = $(e.target);
        rcSubSave.prop('checked', false);
        rcOneTime.prop('checked', 'checked');
        spOptionContainer.prop('required', false);
        spOptionContainer.addClass('d-none');
        spOptionContainer.attr('selected', false);
        spOptionContainer.prepend('<option value="" selected></option>');
        const selectFirstOption = spOptionContainer.find('option:first').val();
        spOptionContainer.find('option').attr('selected', false);
        spOptionContainer.find('option:first').attr('selected', true);
        spOptionContainer.val(selectFirstOption);
        this.quantitySelector.reset();
        this.quantitySelector.stepupReset();
        this.rcUpdatePrice();
    }

    rcReset() {
        
        const rcContainer = this.rechargeSubscribtion,

            oneTimeRadio = rcContainer.find('.rc-onetime-option-selector'),
            subSaveRadio = rcContainer.find('.rc-radio-subsave'),
            sellingPlanSelector = rcContainer.find('.rc-selling-plan-options');
        rcContainer.addClass('d-none');
        oneTimeRadio.find('input[name="onetime"]').prop('checked', 'checked');
        subSaveRadio.find('input[name="subsave"]').prop('checked', false);
        sellingPlanSelector.addClass('d-none');
        sellingPlanSelector.removeAttr('required');
        sellingPlanSelector.prepend('<option value="" selected></option>');
    }

    rcUpdatePrice() {
        let rcContainer = this.rechargeSubscribtion,
            originalPriceContainer = rcContainer.find('.rc-onetime .rc-option-price'),
            discountedPriceContainer = rcContainer.find('.rc-radio-subsave .rc-option-price'),
            selectedSellingPlan = parseFloat(rcContainer.find('.rc-selling-plan-options').val()),
            productVariant = this.product.getVariants(this.activeVariantIndex)[0];
        const spAllocations = productVariant ? productVariant.selling_plan_allocations : [],
            subSaveChecked = $('.rc-radio-subsave input[name="subsave"]').prop('checked');
        this.subscriptionSelected = subSaveChecked;

        if (this.product.isDiscounted(this.activeVariantIndex)) {
            
            const html = this.product.formatPricing(this.activeVariantIndex, {
                html: true,
                comparison: true,
                // label: 'Special Price: ',
                comparisonLabel: 'Special Price: ',
            });

            $('.v4-product-block .header').find('.pricing').html(html !== null ? html : '');

        }
        if (spAllocations.length === 0)
            return;

        // if (this.rechargeSubscribtion.length === 0) {
        //     subSaveChecked = $('.rc_widget__option__input--subsave').prop('checked');
        //     originalPriceContainer = $('.rc-container-wrapper .rc-option__price');
        //     discountedPriceContainer = $('.rc-option__subsave .rc_widget__price--subsave');
        //     selectedSellingPlan = parseFloat($('.rc_widget__option__plans__dropdown').val());
        // }
        if (subSaveChecked) {
            if(productVariant.compare_at_price > productVariant.price) {
                $(this.form).find('.add-to-cart-button .price span').html(formatMoney(productVariant.price, window.moneyFormat));
            } else {
                $(this.form).find('.add-to-cart-button .price span').html(formatMoney(spAllocations[0].per_delivery_price, window.moneyFormat));
            }
        } else {
            $(this.form).find('.add-to-cart-button .price span').html(formatMoney(productVariant.price, window.moneyFormat));
        }
        let originalProductPrice = productVariant.price;
        if(productVariant.compare_at_price > productVariant.price){
            originalProductPrice = productVariant.compare_at_price;
        }
        originalPriceContainer.text(formatMoney(originalProductPrice, window.moneyFormat));
        if (!selectedSellingPlan) {
            discountedPriceContainer.text(formatMoney(spAllocations[0].per_delivery_price, window.moneyFormat));
            return;
        }
        for (let i = 0; i < spAllocations.length; i++) {
            const spAllocation = spAllocations[i];
            if (spAllocation.selling_plan_id === selectedSellingPlan) {
                discountedPriceContainer.text(formatMoney(spAllocation.per_delivery_price, window.moneyFormat));
            }
        }
    }
}
